import { CommentaryV2 } from '@aloft/toolkit-shared';
import { Flex, Input, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useFormContext } from 'react-hook-form';

import { SiteExtraction } from '../../commentary/SiteExtraction/SiteExtraction.tsx';

export const SiteExtractionTabPanels = () => null;

SiteExtractionTabPanels.LeftPanel = () => {
  const { setValue, watch } = useFormContext<CommentaryV2>();

  const commentaryFieldName: FieldPath<CommentaryV2> = 'siteExtraction.commentary';
  const commentary = watch(commentaryFieldName);

  return (
    <Flex flexDirection="column" padding="1rem" gap="1.5rem" width="100%">
      <Typography variant="h2">Site Extraction</Typography>
      <Input
        type="multiline"
        resize="vertical"
        label="Site Commentary"
        value={commentary}
        onChange={(v) => setValue(commentaryFieldName, v)}
        onClear={() => setValue(commentaryFieldName, undefined)}
      />
    </Flex>
  );
};

SiteExtractionTabPanels.RightPanel = () => <SiteExtraction />;
